import { render, staticRenderFns } from "./FormToolsBval.vue?vue&type=template&id=44965664&scoped=true&"
import script from "./FormToolsBval.vue?vue&type=script&lang=js&"
export * from "./FormToolsBval.vue?vue&type=script&lang=js&"
import style0 from "./FormToolsBval.vue?vue&type=style&index=0&id=44965664&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44965664",
  null
  
)

export default component.exports